import { Injectable } from '@angular/core';

export interface IPendoConfig {
  enabled: boolean;
  pendoEnvironment: string;
  pendoId: string;
  appVersion: string;
}

@Injectable()
export class PendoConfig implements IPendoConfig {
  enabled!: IPendoConfig['enabled'];
  pendoEnvironment!: IPendoConfig['pendoEnvironment'];
  pendoId!: IPendoConfig['pendoId'];
  appVersion!: IPendoConfig['appVersion'];
}
